import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Connects to data-controller="clickable-row"
export default class extends Controller {
  static values = { url: String }

  click(event) {
    if (event.target.tagName === 'A' || event.target.closest('a')) return

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    }).then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}
